import SystemMeter from '@components/_shared/SystemMeter';
import SunChart from '@components/Sun/SunChart/SunChart';
import WeatherWidget from '@components/Sun/WeatherWidget';
import UnitList from '@src/components/_shared/UnitListContainer/UnitList';
import { SiteMeta } from '@src/types/SiteMeta';
import storeConnector from '@store/storeConnector';
import { ReactElement } from 'react';

interface SYSProps {
  siteMeta: SiteMeta;
}
function SYS({ siteMeta }: SYSProps): ReactElement {
  return (
    <div className='home-row'>
      <div className='fcol'>
        <SystemMeter />
        <UnitList />
      </div>
      <div className='fcol'>
        <SunChart />
        <WeatherWidget hideForecast={!siteMeta.ui.WeatherForecast_enable} />
      </div>
    </div>
  );
}

export default storeConnector(SYS, {
  config: ['siteMeta'],
});
